import { useConfiguratorState, type Step } from './store';
import styles from './configurator.module.scss';
import { useConfiguratorTranslations } from './translations';

type StepState = 'done' | 'active' | 'future';

export function ConfiguratorStepHeader() {
	const step = useConfiguratorState((s) => s.step);
	const stockVehicle = useConfiguratorState((s) => s.stockVehicle);
	const goToStep = useConfiguratorState((s) => s.goToStep);
	const tr = useConfiguratorTranslations();

	const STEPS: Array<{ key: Step; short: string }> = [
		{ key: 'brand-selector', short: tr.stepBrand },
		{ key: 'model-selector', short: tr.stepModel },
		{ key: 'customizer', short: tr.stepTrim },
	];

	const current =
		step === 'summary'
			? STEPS.length - 1
			: STEPS.findIndex((s) => s.key === step);

	/**
	 * Un'auto in pronta consegna è già costruita: al riepilogo non c'è alcuna
	 * personalizzazione alle spalle, quindi "Personalizza" resta spento invece di
	 * illuminarsi come passo corrente.
	 */
	const customizeOff = step === 'summary' && !!stockVehicle;

	const states: StepState[] = STEPS.map((s, i) => {
		if (customizeOff && s.key === 'customizer') return 'future';
		if (i < current) return 'done';
		if (i === current) return 'active';
		return 'future';
	});

	return (
		<nav className={styles.stepHeader} aria-label="Wizard progress">
			{STEPS.map((s, i) => {
				const isDone = states[i] === 'done';
				const isActive = states[i] === 'active';
				const isFuture = states[i] === 'future';
				// il tratto si accende solo se porta a un passo raggiunto
				const isConnectorDone = isDone && states[i + 1] !== 'future';
				return (
					<div key={s.key} className={styles.stepItem}>
						<button
							className={`${styles.stepBtn} ${isActive ? styles.active : ''} ${
								isDone ? styles.done : ''
							}`}
							disabled={isFuture}
							onClick={() => isDone && goToStep(s.key)}
						>
							<span className={styles.stepDot}>
								<span>{i + 1}</span>
							</span>
							<span className={styles.stepLabel}>{s.short}</span>
						</button>
						{i < STEPS.length - 1 && (
							<span
								className={`${styles.stepConnector} ${
									isConnectorDone ? styles.connectorDone : ''
								}`}
							/>
						)}
					</div>
				);
			})}
		</nav>
	);
}
